import React, { Component, Fragment } from 'react';
import cx from 'classnames';
import Panel from '../../../../components/outline/Panel';
import DragSortTable from '../../../../components/table/DragSortTable';
import { BRAND_TIER_LIST, BRAND_TIER_LIST_STATUS_CLASS_NAME } from '../../../../constants/service/app/brandConstants';
import columns from './columns';
import './BrandTierList.scss';
import { comparePrePropsAndNextProps } from '../../../../lib/common';

class BrandTierList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[nextProps, this.props]]);
  };

  render() {
    const {
      brandTierList,
      setData,
      scrollToBrandElement,
      selectBrandTierItem,
      selectBrandTierList,
      deselectBrandTierItem,
      changeTierOnBrandTierList,
      changeNumberOnDragEnd,
      changeNumberOnBrandTierList,
      deleteBrandTier,
    } = this.props;
    const { currentTierList, newList, selectedList, toggleList } = brandTierList;

    return (
      <div className="brand-tier-list" id="brand-tier-list-scroll">
        {BRAND_TIER_LIST.map((_, index) => {
          const item = newList[index] || [];
          return (
            <Fragment key={index}>
              <Panel name={`tier_${index + 1}`}>
                <div
                  className="panel-header"
                  onClick={() => {
                    setData({
                      path: ['brandTierList', 'toggleList', index],
                      value: !toggleList[index],
                    });
                  }}
                >
                  <div className="title"> {index + 1} 티어</div>
                </div>

                <DragSortTable
                  key={`brand_${index}`}
                  className={cx('store-tier-list-table', { invisible: toggleList[index] })}
                  emptyText="티어를 정한 브랜드가 없습니다."
                  data={item}
                  pageSize={item.length}
                  defaultPageSize={item.length}
                  onDragEnd={(dndInfo) => changeNumberOnDragEnd({ ...dndInfo, tier: index + 1 })}
                  showPagination={false}
                  getTableProps={() => ({ id: `brand-tier-list-scroll_${index + 1}` })}
                  getTdProps={(state, rowInfo) => {
                    return {
                      className: rowInfo ? BRAND_TIER_LIST_STATUS_CLASS_NAME[rowInfo.original.listStatus] : null,
                    };
                  }}
                  columns={() =>
                    columns({
                      tier: index + 1,
                      brandTierList: {
                        newList,
                        selectedList,
                      },
                      currentTierList,
                      setData,
                      selectBrandTierItem,
                      selectBrandTierList,
                      deselectBrandTierItem,
                      changeTierOnBrandTierList,
                      changeNumberOnBrandTierList,
                      scrollToBrandElement,
                      deleteBrandTier,
                    })
                  }
                  style={{
                    maxHeight: 'auto',
                  }}
                />
              </Panel>
            </Fragment>
          );
        })}
      </div>
    );
  }
}

export default BrandTierList;
